import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailsBlacklistComponent } from './emails-blacklist.component';
import { AddEmailsBlacklistComponent } from './add-emails-blacklist/add-emails-blacklist.component';
import { EditEmailsBlacklistComponent } from './edit-emails-blacklist/edit-emails-blacklist.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        EmailsBlacklistComponent,
        AddEmailsBlacklistComponent,
        EditEmailsBlacklistComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule
    ],
    exports: [
        EmailsBlacklistComponent,
    ],
})
export class EmailsBlacklistModule { }
